<template>
    <div id="cfsBatchUpdate">
        <a-modal v-model="visible" :title="labelName" :maskClosable="false"  >
            <template slot="footer">
                <a-button size="small" type="primary" @click="save">Save</a-button>
            </template>
            <a-form :form="form" >
                <a-form-item :label="labelAwb"  v-bind="formItemLayout">
                    <a-input size="small" style="width: 80%" v-model="inputAwb"/>
                    <a-checkbox style="margin-left: 10px" v-model="checkboxAwb"></a-checkbox>
                </a-form-item>
                <a-form-item :label="labelOutboundTime"  v-bind="formItemLayout">
                    <a-input size="small" style="width: 80%" v-model="inputOutboundTime"/>
                    <a-checkbox style="margin-left: 10px" v-model="checkboxOutboundTime"></a-checkbox>
                </a-form-item>
                <a-form-item :label="labelInboundTime"  v-bind="formItemLayout" >
                    <a-input size="small" style="width: 80%" v-model="inputInboundTime"/>
                    <a-checkbox style="margin-left: 10px" v-model="checkboxInboundTime"></a-checkbox>
                </a-form-item>

            </a-form>
        </a-modal>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    export default{
        data(){
            return{
                labelName: '',
                labelAwb: 'AWB_HBL',
                labelOutboundTime: 'In-transit Outbound Time',
                labelInboundTime: 'In-transit Inbound Time',
                inputAwb:'',
                checkboxAwb:false,
                inputOutboundTime:'',
                checkboxOutboundTime:false,
                inputInboundTime:'',
                checkboxInboundTime:false,
                ajaxtype: '',
                uids: [],
                visible: false,
                form:this.$form.createForm(this),
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
            }
        },
        watch:{
            inputAwb(){
                if(this.inputAwb.length > 0) {
                    this.checkboxAwb=true;
                } else {
                    this.checkboxAwb=false;
                }
            },
            inputOutboundTime() {
                if(this.inputOutboundTime.length > 0) {
                    this.checkboxOutboundTime=true;
                } else {
                    this.checkboxOutboundTime=false;
                }
            },
            inputInboundTime() {
                if(this.inputInboundTime.length > 0) {
                    this.checkboxInboundTime=true;
                } else {
                    this.checkboxInboundTime=false;
                }
            }
        },
        methods:{
            show(name,type,uids){
                this.uids = uids
                this.labelName = name
                this.visible = true
                this.ajaxtype = type

                this.resetData();
            },
            save(){
                  // 至少选一个，否则报错
                   if(!(this.checkboxAwb || this.checkboxOutboundTime || this.checkboxInboundTime)) {
                       this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'));
                       return;
                   }
                   let params = {}
                   let ajaxTypeName = ''
                   if(this.ajaxtype == 'cfsBatchUpdate'){
                       ajaxTypeName = api.CFSBATCHUPDATE
                       params = {
                           "uids": this.uids,
                           "awbHbl": this.inputAwb,
                           "awbHblCheck": this.checkboxAwb,
                           "outboundTime": this.inputOutboundTime,
                           "outboundTimeCheck":this.checkboxOutboundTime,
                           "inboundTime": this.inputInboundTime,
                           "inboundTimeCheck": this.checkboxInboundTime
                       }
                   }
                   ajax.post(ajaxTypeName,params).then(res=>{
                       if(res.code == 200){
                           this.$message.success(res.msg)
                           this.visible = false
                       }else{
                           this.$customMessage.warning(res.msg)
                       }
                   })


            },
            resetData() {
                this.inputAwb = '';
                this.inputOutboundTime = '';
                this.inputInboundTime = '';
            }
        }
    }
</script>